import React from 'react';
import { useLanguage } from '@contexts/LanguageContext';
import { Card } from '@components/common';
import Icon from '@components/Icon/Icon';
import './ConsumptionCard.scss';

const ConsumptionCard = ({ consumption, displayType = 'grid', onClick, actions }) => {
    const { t } = useLanguage();

    const formatDate = (dateString) => {
        if (!dateString) return '-';
        const date = new Date(dateString);
        return date.toLocaleDateString('fr-FR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    };

    const formatDateTime = (dateString) => {
        if (!dateString) return '-';
        const date = new Date(dateString);
        return date.toLocaleDateString('fr-FR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const handleClick = () => {
        if (onClick) {
            onClick(consumption);
        }
    };

    if (displayType === 'list') {
        return (
            <div className="consumption-card consumption-card--list" onClick={handleClick}>
                <div className="consumption-card__content">
                    <div className="consumption-card__left">
                        <div className="consumption-card__icon">
                            <Icon icon="arrow-down" size="lg" color="#E74C3C" />
                        </div>
                        <div className="consumption-card__info">
                            {consumption.resource?.name && (
                                <h4 className="consumption-card__resource">
                                    {consumption.resource?.name}
                                </h4>
                            )}
                            <div className="consumption-card__detail-item">
                                <Icon icon="user" className="consumption-card__detail-icon" />
                                <span className="consumption-card__detail-text">
                                    {consumption.user?.name || consumption.user?.email || t('consumption.unknown_user')}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="consumption-card__right">
                        <div className="consumption-card__date">
                            <Icon icon="calendar" className="consumption-card__date-icon" />
                            <span className="consumption-card__date-text">
                                {formatDate(consumption.consumed_at)}
                            </span>
                        </div>
                        <div className="consumption-card__quantity">
                            <span className="consumption-card__quantity-value">
                                -{consumption.quantity_consumed}
                            </span>
                            <span className="consumption-card__quantity-unit">
                                {t('consumption.units')}
                            </span>
                        </div>
                    </div>
                    {actions && (
                        <div className="consumption-card__actions">
                            {actions}
                        </div>
                    )}
                </div>
                {consumption.notes && (
                    <div className="consumption-card__notes">
                        <Icon icon="file-alt" className="consumption-card__notes-icon" />
                        <p className="consumption-card__notes-text">{consumption.notes}</p>
                    </div>
                )}
            </div>
        );
    }

    // Grid display (default)
    return (
        <Card className="consumption-card consumption-card--grid" onClick={handleClick} hoverable>
            <div className="consumption-card__content">
                <div className="consumption-card__header">
                    <div className="consumption-card__info">
                        <h4 className="consumption-card__resource">
                            {consumption.resource?.name || t('consumption.unknown_resource')}
                        </h4>
                        <div className="consumption-card__quantity">
                            <Icon icon="arrow-down" size="lg" />
                            <span className="consumption-card__quantity-unit">
                               {consumption.quantity_consumed}  {t('consumption.units')}
                            </span>
                        </div>
                    </div>
                </div>

                <div className="consumption-card__details">
                    <div className="consumption-card__field">
                        <div className="consumption-card__field-header">
                            <Icon icon="user" className="consumption-card__field-icon" />
                            <span className="consumption-card__value">
                                {consumption.user?.name || consumption.user?.email || t('consumption.unknown_user')}
                            </span>
                        </div>
                    </div>

                    <div className="consumption-card__field">
                        <div className="consumption-card__field-header">
                            <Icon icon="calendar" className="consumption-card__field-icon" />
                            <span className="consumption-card__value">{formatDate(consumption.consumed_at)}</span>
                        </div>
                    </div>
                </div>

                {consumption.notes && (
                    <div className="consumption-card__notes">
                        <p className="consumption-card__value consumption-card__notes-text">
                            {consumption.notes}
                        </p>
                    </div>
                )}

                {actions && (
                    <div className="consumption-card__actions">
                        {actions}
                    </div>
                )}
            </div>
        </Card>
    );
};

export default ConsumptionCard;
